export const containsSpecialCharacters = (str: string | null): boolean => {
  if (typeof str !== 'string' || str === null) {
    return false;
  }
  const specialCharRegex = /[@#$%^*{}[\]_<>]/;
  return specialCharRegex.test(str);
};

export const containsDigit = (str: string | null): boolean => {
  if (typeof str !== 'string' || str === null) {
    return false;
  }
  const digitRegex = /\d/;
  return digitRegex.test(str);
};

export const isDigitsOnly = (str: string | null | undefined): boolean => {
  if (typeof str !== 'string') {
    return false;
  }

  return /^\d+$/.test(str.trim());
};

export const compareTransformAndSort = (
  valueA: string | number,
  valueB: string | number
): number => {
  const regex = /-?\d+(\.\d+)?/;

  const clean = (val: string | number): number => {
    const match = regex.exec(String(val));
    return match ? Number(match[0]) : 0;
  };
  return clean(valueA) - clean(valueB);
};

export const isOnlyZeroes = (str: string | null | undefined): boolean => {
  if (typeof str !== 'string') {
    return false;
  }

  return /^0+$/.test(str.trim());
};

export const isAlphabeticOnly = (str: string | null | undefined): boolean => {
  if (typeof str !== 'string' || str === null) {
    return false;
  }

  const alphabeticRegex = /^[A-Za-z]*$/;
  return alphabeticRegex.test(str);
};

export const safeStringify = (value: unknown): string => {
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return '';
};
